import React from 'react';

const Loader = (props) => {
    return (
        <div className="position-absolute col-12 m-auto text-center mt-4">
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
};

export default Loader;
